module.exports = __webpack_public_path__ + "assets/img/zan-2.7c501f2f.png";